/**
 * Configuración central de datos corporativos de ACOMA.
 *
 * Cualquier dato de la empresa (nombre, dominio, email, WhatsApp, logo,
 * URLs de productos y redes sociales) se edita aquí una sola vez, en lugar
 * de repetirlo en cada componente.
 */

export const SITE = {
  name: 'ACOMA',
  url: 'https://acomalabs.cl',
  email: 'contacto@acoma.cl',
  whatsappNumber: '56953907106',

  // Logo principal.
  // TODO: reemplazar por un asset local (ej. '/logo.png') una vez que el
  // archivo se suba a /public, para eliminar la dependencia de storage externo.
  logo: 'https://storage.helloreaddy.io/project_files/4a7c31bf-850e-47c8-8466-3ea8f7276572/cef61d3f-6708-4f44-9c1a-07b4aba231ce_compressed_ChatGPT-Image-Sep-8-2026-09_54_19-PM.webp',

  // URLs de productos propios. Si está vacío, el CTA correspondiente se oculta.
  productUrls: {
    privirooms: '',
    aprOnline: '',
  },

  // URL del Portal ACOMA (acceso a la app / inicio de sesión).
  // Dejar vacío mientras no exista; el botón "Iniciar sesión" usará esta URL
  // en cuanto la sincronices con tu aplicación.
  portalUrl: '',

  // Redes sociales. Solo agregar perfiles reales y verificados. Vacío = no se muestra.
  social: {
    linkedin: '',
  },
};